import { ref as u, onMounted as w, watch as m, onBeforeUnmount as g } from "vue";
let l = 0, r = "", f = "", s = "", a = "";
const d = u("0px");
function y(c) {
  if (typeof document > "u")
    return;
  const e = document.documentElement;
  let o, t = !1;
  const n = () => {
    e.style.marginRight = r, e.style.overflow = f, e.style.overflowX = s, e.style.overflowY = a, d.value = "0px";
  };
  w(() => {
    o = m(c, (v) => {
      if (v) {
        if (!l) {
          const i = window.innerWidth - e.offsetWidth;
          i > 0 && (r = e.style.marginRight, e.style.marginRight = `${i}px`, d.value = `${i}px`), f = e.style.overflow, s = e.style.overflowX, a = e.style.overflowY, e.style.overflow = "hidden", e.style.overflowX = "hidden", e.style.overflowY = "hidden";
        }
        t = !0, l++;
      } else
        l--, l || n(), t = !1;
    }, {
      immediate: !0
    });
  }), g(() => {
    o == null || o(), t && (l--, l || n(), t = !1);
  });
}
export {
  d as lockHtmlScrollRightCompensationRef,
  y as useLockHtmlScroll
};
